import React from 'react';
import ResponsiveOverlay from '@/components/ResponsiveOverlay/ResponsiveOverlay';
import Button from '../Buttons/Button/Button';
import type { BookingErrorCopy } from '@/lib/booking/bookingErrors';
import './bookingPopupLayer.css';

interface BookingErrorModalProps {
  /** What went wrong; the popup is hidden while null. */
  error: BookingErrorCopy | null | undefined;
  onClose: () => void;
}

/**
 * Shown when Book can't open the hotel booking page (hotel not in inventory, login needed,
 * service down). Same look as BookingSsoBlockedModal, in place of a corner toast; a centred
 * dialog on mobile too, since a full-height sheet would be mostly empty for a short message.
 */
const BookingErrorModal: React.FC<BookingErrorModalProps> = ({ error, onClose }) => {
  if (!error) return null;

  return (
    <ResponsiveOverlay onClose={onClose} presentation="dialog" className="booking-popup-overlay">
      <div
        role="alertdialog"
        aria-labelledby="booking-error-title"
        aria-describedby="booking-error-message"
        className="flex flex-col items-center gap-4 bg-white rounded-2xl max-w-[420px] w-[calc(100vw-32px)] p-8 text-center font-manrope"
      >
        <div className="text-4xl leading-none" aria-hidden="true">🏨</div>

        <h2 id="booking-error-title" className="m-0 text-xl font-bold text-gray-900">
          {error.title}
        </h2>

        <p id="booking-error-message" className="m-0 text-[15px] text-gray-500 leading-relaxed">
          {error.message}
        </p>

        <Button variant="primary" size="md" onClick={onClose}>
          OK
        </Button>
      </div>
    </ResponsiveOverlay>
  );
};

export default BookingErrorModal;
